import {BrowserRouter} from "react-router-dom";
import {QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {AuthDataProvider} from "context/AuthDataProvider";
import {GlobalDataProvider} from "context/GlobalDataProvider";
import {ConfigDataProvider} from "context/ConfigDataProvider";
import {useEffect, useState} from "react";
import Loader from "layout/mantis/components/Loader";
import ThemeCustomization from "layout/mantis";
import RTLLayout from "layout/mantis/components/RTLLayout";
import ScrollTop from "layout/mantis/components/ScrollTop";
import Notistack from "layout/mantis/components/third-party/Notistack";
import Routes from "routes";
import Locales from "layout/mantis/components/Locales";
import Snackbar from "layout/mantis/components/@extended/Snackbar";

const queryClient = new QueryClient();

function App() {
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        // Load Theme before show desing
        setLoading(true);
    }, []);

    if (!loading) return <Loader />;

    return (
        <QueryClientProvider client={ queryClient }>
            <GlobalDataProvider>
                <ConfigDataProvider>
                    <BrowserRouter>
                        <ThemeCustomization>
                            <RTLLayout>
                                <Locales>
                                    <ScrollTop>
                                        <AuthDataProvider>
                                            <>
                                                <Notistack>
                                                    <Routes />
                                                    <Snackbar />
                                                </Notistack>
                                            </>
                                        </AuthDataProvider>
                                    </ScrollTop>
                                </Locales>
                            </RTLLayout>
                        </ThemeCustomization>
                    </BrowserRouter>
                </ConfigDataProvider>
            </GlobalDataProvider>
        </QueryClientProvider>
    );
}

export default App;
